module.exports = __webpack_public_path__ + "img/us4.b789dbfb.jpg";